import apiRequestType from "../../apiRequestType";
import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";

const getAccessReportCSV = (
  usergroupId,
  timeZone,
  fromDate,
  toDate,
  userId = 0
) => {
  const userGroupIds = usergroupId?.toString();

  return apiRequestType(
    apiTypes.GET,
    apiConstants.REPORT.ACCESS_REPORT.GET_ACCESS_REPORT_CSV(
      userGroupIds,
      timeZone,
      fromDate,
      toDate,
      userId
    )
  );
};

export default getAccessReportCSV;
